import PolicyPage from './PolicyPage';

export default function EGovernment() {
  return <PolicyPage />;
}
